import {
  IComboBox,
  IComboBoxOption,
  Panel,
  PanelType,
  TextField,
  Toggle,
} from "@fluentui/react";
import React, { useCallback, useState } from "react";
import { PanelHeader } from "../../../../components/PanelHeader/PanelHeader";
import { PanelFooter } from "../../../../components/PanelFooter/PanelFooter";
import { IOpenPanel } from "../../../../interfaces/base/IPanel";
import { IUbicacionDTO } from "../../../../interfaces/ubicacion/IUbicacion";
import { UseUbicacionEditar } from "./UseUbicacionEditar";
import { MessageBarResponse } from "../../../../components/MessageBar/MessageBarResponse";
import { ProgressBarLoading } from "../../../../components/ProgressBarLoading/ProgressBarLoading";
import { UseComboEstado } from "./UseComboEstado";
import { ComboBoxBase } from "../../../../components/comboBoxComponent/ComboBoxBase";

export interface IPanelUbicacionEditar extends IOpenPanel {
  ubicacionData: IUbicacionDTO;
}

const PanelUbicacionEditar = (props: IPanelUbicacionEditar) => {
  const {
    command,
    setCommand,
    putEditarUbicacion,
    loading,
    setLoading,
    reset,
    mensaje,
    setMensaje,
    status,
    disableForm,
  } = UseUbicacionEditar(props);
  const {
    dataComboEstado,
    onClickComboEstado,
    _onkeyUpSearchEstado,
    comboBoxRefEstado,
  } = UseComboEstado(props.isOpen);

  const onChangeCombo = (
    event: React.FormEvent<IComboBox>,
    option?: IComboBoxOption,
    type?: string
  ) => {
    if (event != undefined) {
      if (option != undefined) {
        switch (type) {
          case "estado":
            setCommand({
              ...command,
              estado: option.key.toString(),
            });
            break;
          default:
            break;
        }
      }
    }
  };

  const onRenderHeader = useCallback(
    () => (
      <>
        <PanelHeader
          nameIconHeader="edit"
          textHeader={`Movilizaciones`}
          subTextHeader={`Editar lugar`}
        />
      </>
    ),
    []
  );

  const onRenderFooter = useCallback(
    () => (
      <>
        <PanelFooter
          texto="Actualizar"
          // texto2={"Salir"}
          disableButton={disableForm}
          onClick={putEditarUbicacion}
          onDismiss={reset}
        />
      </>
    ),
    [command, disableForm]
  );

  const onReset = () => {
    setLoading(false);
    setMensaje("");
  };

  return (
    <>
      <Panel
        type={PanelType.smallFixedFar}
        onRenderHeader={onRenderHeader}
        onRenderFooter={!loading && mensaje == "" ? onRenderFooter : undefined}
        isFooterAtBottom
        isOpen={props.isOpen}
        onDismiss={props.onDismiss}
      >
        <div className="ms-Grid" dir="ltr">
          <div hidden={mensaje == ""}>
            <MessageBarResponse
              objetoResponse={{ codigo: status, mensaje: mensaje }}
              close={true}
            />
          </div>
          <div hidden={!loading}>
            <ProgressBarLoading></ProgressBarLoading>
          </div>
        </div>
        <div className="ms-Grid-row" hidden={loading || mensaje != ""}>
          <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
            <TextField
              type="text"
              label="Código de la Ubicación"
              placeholder="Ingrese Códigoo"
              autoComplete="off"
              value={command.codigo}
              onChange={(event, newValue) => {
                if (newValue != null) {
                  setCommand({ ...command, codigo: newValue });
                }
              }}
            />
          </div>
        </div>

        <div className="ms-Grid-row" hidden={loading || mensaje != ""}>
          <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
            <TextField
              type="text"
              label="Nombre de la Ubicación"
              placeholder="Ingrese Nombre"
              autoComplete="off"
              value={command.nombre}
              onChange={(event, newValue) => {
                if (newValue != null) {
                  setCommand({ ...command, nombre: newValue });
                }
              }}
            />
          </div>
        </div>

        <div className="ms-Grid-row" hidden={loading || mensaje != ""}>
          <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
            <ComboBoxBase
              title="Estado:"
              componentRef={comboBoxRefEstado}
              KeyUp={_onkeyUpSearchEstado}
              onClick={onClickComboEstado}
              options={dataComboEstado}
              selectedKey={command.estado != null ? command.estado : undefined}
              onChange={(e: React.FormEvent<IComboBox>, option) => {
                onChangeCombo(e, option, "estado");
              }}
            />
          </div>

          <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
            <Toggle
              label="Requiere Bus"
              placeholder="placeholder"
              onText="Si"
              offText="No"
              checked={command ? command.requiereTransporte : false}
              onChange={(e, checked) =>
                setCommand({ ...command, requiereTransporte: !!checked })
              }
            />
          </div>
          <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
            <Toggle
              label="Requiere Vuelo Comercial"
              placeholder="placeholder"
              onText="Si"
              offText="No"
              checked={command ? command.requiereVueloComercial : false}
              onChange={(e, checked) =>
                setCommand({ ...command, requiereVueloComercial: !!checked })
              }
            />
          </div>
        </div>
      </Panel>
    </>
  );
};

export { PanelUbicacionEditar };
